import { currentDate } from '@shared/utils/date.utils';
import { SelectModel } from '@shared/form/select.model';

export const BET_TYPES = Object.freeze({
  '1X2': '1X2',
  'AHDP': 'AHDP',
  'O/U': 'O/U',
  'Special/Multiple': 'Special/Multiple'
});

export const BET_SELECTIONS = Object.freeze({
  'Draw': 'Draw',
  'Home': 'Home',
  'Away': 'Away',
  'Under': 'Under',
  'Over': 'Over'
});

export class SearchFormModel {
  constructor() {
    this._dateFrom = currentDate();
    this._dateTo = currentDate();
    this._league = '';
    this._betType = '';
    this._betSelection = '';

    this._betTypeSelect = new SelectModel(Object.assign({'': 'ALL'}, BET_TYPES));
    this._betSelectionSelect= new SelectModel(Object.assign({'': 'ALL'}, BET_SELECTIONS));
    this._leagueSelect = null;

    this._leagues = [];

    this.props = {
      betType: {
        readOnly: false,
      },
      betSelection: {
        readOnly: true
      }
    }
  }

  set dateFrom(dateFrom) {
    this._dateFrom = dateFrom;
  }

  get dateFrom() {
    return this._dateFrom;
  }

  set dateTo(dateTo) {
    this._dateTo = dateTo;
  }

  get dateTo() {
    return this._dateTo;
  }

  set league(league) {
    this._league = league;
  }

  get league() {
    return this._league;
  }

  set betType(betType) {
    this._betType = betType;
  }

  get betType() {
    return this._betType;
  }

  set betSelection(betSelection) {
    this._betSelection = betSelection;
  }

  get betSelection() {
    return this._betSelection;
  }

  set stakeRange(stakeRange) {
    this._stakeRange = stakeRange;
  }

  get stakeRange() {
    return this._stakeRange;
  }

  get betTypeSelect() {
    return this._betTypeSelect;
  }

  get betSelectionSelect() {
    return this._betSelectionSelect;
  }

  get leagueSelect() {
    return this._leagueSelect;
  }

  set leagues(leagues) {
    this._leagueSelect =  new SelectModel(Object.assign({'': 'ALL'}, leagues));
  }

  toPayload() {
    return {
      from: this.dateFrom,
      to: this.dateTo,
      league: this.league,
      betType: this.betType,
      bet: this.betSelection,
    }
  }

  reset() {
    this._dateFrom = currentDate();
    this._dateTo = currentDate();
    this._league = '';
    this._betType = '';
    this._betSelection = '';
  }
}



// WEBPACK FOOTER //
// ./client/app/pages/customer/betoverview/component/overview/model/searchform.model.js